<template>
  <div class="terms-wrapper">
    <VBlock class="unsigned-user-info-wrapper" v-if="!isSign" :padding="[15, 15, 20, 15]">
      <VSpan
        text="비회원으로 배달의민족 바로결제 서비스를 이용하는 경우 이벤트 할인 등의 서비스 이용이 제한됩니다."
        :color="TextColor.gray2"
        :size="11"
      />
    </VBlock>
    <VBlock class="rider-info" :direction="Direction.column" :padding="[20, 15, 20, 15]" :sort="Sort.left_top">
      <VSpan
        class="info-text"
        text="라이더의 안전을 위해 폭우/폭설 또는 집회와 같이 배달이 어려운 경우 배달이 지연되거나 주문이 취소 될 수 있습니다."
        :size="11"
        :color="TextColor.gray2"
      />
      <VBlock v-if="shopMessage" :margin="[15, 0, 0, 0]" :sort="Sort.left_top">
        <VSpan class="shop-message" :text="shopMessage" :size="11" :color="TextColor.gray2" />
      </VBlock>
    </VBlock>
    <PreOrderTerm v-show="show.service" title="이용약관" :content="terms.service" />
    <PreOrderTerm v-show="show.deliveryCaution" title="배달상품 주의사항" :content="terms.deliveryCaution" />
    <PreOrderTerm v-show="show.etf" title="전자금융거래 이용약관" :content="terms.etf" />
    <PreOrderTerm v-show="show.policy" title="개인정보 수집 및 이용" :content="terms.policy" />
    <VBlock class="info-wrapper" v-if="isSign" :direction="Direction.column" :sort="Sort.center_center">
      <VSpan class="info-text" text="위 내용을 확인하였으며 결제에 동의합니다." :size="11" :color="TextColor.gray2" />
    </VBlock>
    <VBlock class="info-wrapper" v-else :direction="Direction.column" :sort="Sort.center_center">
      <VSpan class="info-text" text="본인이 만 14세 이상이고," :size="11" :color="TextColor.gray2" />
      <VSpan class="info-text" text="위 내용을 확인하였으며 결제에 동의합니다." :size="11" :color="TextColor.gray2" />
    </VBlock>
  </div>
</template>

<script>
import PreOrderTerm from '../../layouts/organisms/PreOrderTerm'
import VBlock, { Direction, Sort } from '../../layouts/molecules/VBlock'
import VSpan, { TextColor } from '../../layouts/atoms/VSpan'

export default {
  name: 'PreOrderTermsContainer',
  components: { VSpan, VBlock, PreOrderTerm },
  data() {
    return {
      Direction,
      Sort,
      TextColor
    }
  },
  computed: {
    terms() {
      return this.$store.getters['preOrder/terms']
    },
    isSign() {
      return this.$store.getters.isSign
    },
    isUnSign() {
      return !this.isSign
    },
    isFirstOrder() {
      return this.$store.getters['preOrder/isFirstOrder']
    },
    show() {
      return {
        service: this.isUnSign,
        deliveryCaution: true,
        thirdParty: this.isSign,
        thirdPartyNon: this.isUnSign,
        etf: this.isUnSign,
        policy: this.isUnSign || this.isFirstOrder
      }
    },
    shopMessage() {
      return this.$store.getters['preOrder/shopMessage']
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.terms-wrapper {
  width: 100%;
  height: auto;
  /* padding-top: 10px; */

  .unsigned-user-info-wrapper {
    border-bottom: 1px solid $light-gray-5;
  }

  .rider-info {
    border-bottom: 1px solid $light-gray-5;
  }

  .shop-message {
    white-space: pre;
  }

  .info-wrapper {
    box-sizing: border-box;

    padding: 20px 15px 0 15px;
    padding-bottom: 90px;
  }
}
</style>
